import { RazorButton, RazorModal } from "../../razor-reuse";
import React from "react";
import { ALL_ICONS } from "../../../assets/icons/AllIcons";
import "./Reusablemodal.css";

interface myComponentProps {
  visible?: boolean;
  onClose?: () => void;
  children?: React.ReactNode;
  title?: string;
  hideCancel?: boolean;
  hideBtn?: boolean;
  onBtnClick?: () => void;
  loading?: boolean;
  disable?: boolean;
  btnLabel?: string;
  classname?: string;
  deleteType?: boolean;
  deleteText?: string;
  btnColor?: string;
  titleBtnlabel?: string;
  onTitleBtnClick?: () => void;
  loadingTitleBtn?: boolean;
  loadingText?: string;
  hideClose?: boolean;
  cancelText?: string;
  onCancel?: () => void;
}

const ReuseModal = ({
  onClose,
  visible,
  children,
  title,
  disable,
  hideBtn,
  hideCancel,
  loading,
  onBtnClick,
  btnLabel,
  classname,
  deleteText,
  deleteType,
  btnColor,
  onTitleBtnClick,
  titleBtnlabel,
  loadingTitleBtn,
  hideClose,
  loadingText,
  cancelText,
  onCancel,
}: myComponentProps) => {
  return (
    <>
      <RazorModal
        className={`reuseable-smart-send-modal-start-box-modal ${
          deleteType ? "reuseable-smart-send-modal-start-box-modal-delete" : ""
        } ${classname || ""}`}
        dontShowClose
        visible={visible}
        onClose={() => {
          if (!loading) onClose?.();
        }}
        onBtnClick={(e) => {
          e.preventDefault();
        }}
        outerClose={hideClose}
      >
        {" "}
        {/* header start */}
        <div className="new-header-box-wrap">
          <p className="title">{title || ""}</p>
          {/* title btn start */}
          {titleBtnlabel && (
            <>
              {" "}
              <RazorButton
                disabled={disable}
                loading={loadingTitleBtn}
                className="btn btn-title "
                onClick={onTitleBtnClick}
                label={titleBtnlabel || `Submit`}
                color={
                  btnColor
                    ? btnColor
                    : !btnColor && deleteType
                    ? "error-light"
                    : ("black-light" as any)
                }
              />
            </>
          )}
          {/* title btn end */}
          {!hideClose && (
            <div onClick={onClose} className="close-wrap">
              <figure className="img-box">{ALL_ICONS?.close_modal}</figure>
            </div>
          )}
        </div>
        {/* header end */}
        <div className="reuseable-smart-send-modal-start-box">
          <div className="children-box">
            {/* delete text start here */}
            {deleteType && (
              <>
                <p className="delete-text">{deleteText || ""}</p>
              </>
            )}
            {/* delete text end here */}
            {children}
          </div>

          {/* btn box start */}
          {!hideBtn && (
            <div
              className={`two-btn-box ${
                deleteType ? `two-btn-box-delete` : ""
              }`}
            >
              {!hideCancel && (
                <RazorButton
                  className="btn btn-cancel"
                  label={cancelText || "Cancel"}
                  color="black-light"
                  onClick={() => {
                    if (onCancel) {
                      onCancel();
                    } else {
                      if (!loading) onClose?.();
                    }
                  }}
                />
              )}
              <RazorButton
                disabled={disable}
                loading={loading}
                className={`btn ${loading && loadingText ? "btn-big" : ""}`}
                onClick={onBtnClick}
                label={btnLabel || `Submit`}
                loaderText={loadingText || ""}
                color={
                  btnColor
                    ? btnColor
                    : !btnColor && deleteType
                    ? "error-light"
                    : ("black-light" as any)
                }
              />
            </div>
          )}
          {/* btn box end */}
        </div>
      </RazorModal>
    </>
  );
};

export default ReuseModal;
